

exports.__esModule = true;

var _angular = require('angular');

var _squid = require('squid');

exports['default'] = (0, _angular.$registerDirective)('prefix-attrs-with', function () {
    return {
        restrict: 'A',
        link: function link(scope, elem, attrs, controller) {
            var prefix = attrs.prefixAttrsWith;

            if (prefix && prefix.length) {
                ['id', 'for', 'name'].forEach(function (attrName) {
                    var base = attrs[attrName];

                    if (base) {
                        elem.attr(attrName, _squid.$util.dasherizeToCamel(prefix + '-' + base));
                    }
                });
            }
        }
    };
});


_angular.$registerDirective;

_squid.$util;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./components/xo-ui-components/src/prefix-attrs-with/directive.js
// module id = ./components/xo-ui-components/src/prefix-attrs-with/directive.js
// module chunks = 1